export const getClientes = 'clientes'
